import { Controller } from "@hotwired/stimulus";

// Connect sidebar menu items with arbitrary highlight targets elsewhere on the page.
// Usage on trigger element (e.g. <li>):
//   data-controller="hover-highlight"
//   data-hover-highlight-id-value="student-42"
//   data-action="mouseenter->hover-highlight#enter mouseleave->hover-highlight#leave focus->hover-highlight#enter blur->hover-highlight#leave"
// Usage on target element(s):
//   data-hover-highlight-for="student-42"
// All matching targets get the .highlight-accent utility class while hovered/focused.
export default class extends Controller {
  static values = { id: String }

  enter() {
    if (!this.hasIdValue) return
    this._targets().forEach(el => el.classList.add("highlight-accent"))
  }

  leave() {
    if (!this.hasIdValue) return
    this._targets().forEach(el => el.classList.remove("highlight-accent"))
  }

  _targets() {
    return document.querySelectorAll(`[data-hover-highlight-for="${this.idValue}"]`)
  }
}
